import { useEffect } from "react";
import { withAppContext } from "src/store/initAppContext";
import styled, { withTheme } from "styled-components";
import config from "src/config/config";
import { theme } from "styled-tools";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PlaceholderImage from 'src/components/Placeholder';

function Place9BetsWinUpTo99XPromo(props: any) {
    const {
        app: { brandId },
        theme,
    } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const games = [
        {
            name: "Monopoly Roulette",
            image: theme.image.ChooseYrGmeMonopolyRouletteImage,
            link: "/live-casino/evolution/monopoly-roulette",
        },
        {
            name: "Red Baron",
            image: theme.image.ChooseYrGmeRedBaronImage,
            link: "/instant-games/evolution/red-baron",
        },
        {
            name: "Ice Fishing",
            image: theme.image.ChooseYrGmeIceFishingImage,
            link: "/live-casino/evolution/ice-fishing",
        },
    ];

    // function getDomain(brandId: any) {
    //     if ([31, 32, 61, 35, 36].includes(brandId)) return "Yolo247";
    //     if ([37, 39, 40].includes(brandId)) return "Fomo7";
    //     if ([46, 47, 49].includes(brandId)) return "Fun88";
    //     return "Iw247";
    // }
    // const domainName = getDomain(brandId);
    const isPK = brandId && (brandId === 35 || brandId === 36 || brandId === 37 || brandId === 49);
    const maxWinningAmt = (brandId === 61) ? "$5265.89" : isPK ? "PKR 15,00,000" : "₹5,00,000";
    const minQualifyingBetAmt = (brandId === 61) ? "$0.53" : isPK ? "PKR 150" : "₹50";

    return (
        <>
            <InformationWrapper>
                {/* =========================
                    TOP CONTENT
                ========================== */}
                <TopSection>
                    <h1>3 GAMES. 3 GUARANTEED WINS. NO LUCK REQUIRED.</h1>

                    <p className="top-para">
                        Play Your Favourite Evolution Games And Complete 9 Qualifying
                        Bets For A Guaranteed Reward Of Up To 99x
                        <br className="desktop-break" />
                        Your Qualifying Bet — With A Chance To Win On Every One Of The
                        3 Participating Games.
                    </p>

                    <p className="promotion-period">
                        Promotion Period:{" "}
                        <strong>1 September – 31 October 2026</strong>
                    </p>
                </TopSection>

                {/* =========================
                    CHOOSE YOUR GAME
                ========================== */}
                <Section>
                    <h2>Choose Your Game</h2>

                    <p className="section-description">
                        Complete 9 Qualifying Bets On Each Participating Game To Unlock
                        A Reward.
                    </p>

                    <GamesWrapper>
                        {games.map((game) => (
                            <GameLink
                                key={game.name}
                                href={game.link}
                                aria-label={`Play ${game.name}`}
                            >
                                <LazyLoadImage
                                    src={`${config.imageV3Host}/static/cashsite/${game.image}`}
                                    alt={game.name}
                                    effect="none"
                                    placeholder={<PlaceholderImage />}
                                />
                            </GameLink>
                        ))}
                    </GamesWrapper>
                </Section>

                {/* =========================
                    HOW TO CLAIM
                ========================== */}
                <Section>
                    <h2>How To Claim</h2>

                    <ImageWrapper>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.Place9BetsWinUpTo99XHowToClaimImage}`}
                            alt="How To Claim"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </ImageWrapper>
                </Section>

                {/* =========================
                    TERMS & CONDITIONS
                ========================== */}
                <Section>
                    <h2>Terms & Conditions</h2>

                    <TermsList>
                        <li>
                            Promotion Is Valid From{" "}
                            <strong>1 September To 31 October 2026.</strong>
                        </li>

                        <li>
                            Participating Games:{" "}
                            <strong>
                                Monopoly Roulette, Red Baron And Ice Fishing.
                            </strong>
                        </li>

                        <li>
                            The Minimum Qualifying Bet Is{" "}
                            <strong>{minQualifyingBetAmt} Per Bet.</strong>
                        </li>

                        <li>
                            The Maximum Winnings Are{" "}
                            <strong>{maxWinningAmt} Per Participating Game.</strong>
                        </li>

                        <li>
                            Players Can Win{" "}
                            <strong>Once Per Participating Game,</strong> For A
                            Maximum Of Three Rewards.
                        </li>

                        <li>
                            Winnings Will Be Credited Directly To The Player&apos;s
                            Wallet.
                        </li>

                        <li>
                            Cancelled, Voided Or Invalid Bets Will Not Count Towards
                            The Promotion.
                        </li>

                        <li>Regular Terms & Conditions Apply.</li>
                    </TermsList>
                </Section>
            </InformationWrapper>
        </>
    );
}

export default withTheme(withAppContext(Place9BetsWinUpTo99XPromo));

/* =========================================================
   MAIN WRAPPER
========================================================= */

const InformationWrapper = styled.div`
    width: calc(100% - 2.4em);
    min-height: 100vh;
    height: auto;

    padding: 3rem 0 5rem;
    margin: 0 1.2em;

    display: flex;
    flex-direction: column;
    align-items: center;

    background:
        url(${config.imageV3Host}/static/cashsite/${theme(
            "image.Place9BetsWinUpTo99XBackground"
        )});

    background-position: top center;
    background-size: cover;
    background-repeat: no-repeat;

    overflow: hidden;
    position: relative;

    color: #fff;

    h1,
    h2,
    p {
        margin: 0;
        padding: 0;
    }

    h1,
    h2 {
        font-style: normal;
        font-weight: 700;
        text-align: center;
        line-height: normal;
    }

    h1 {
        color: #97c6ff;
        font-size: 22px;
        text-transform: uppercase;
    }

    h2 {
        color: #97c6ff;
        font-size: 20px;
        text-transform: capitalize;
    }

    @media (max-width: 768px) {
        width: 100%;
        margin: 0;

        padding: 2rem 15px 4rem;

        background-position: top center;

        h1 {
            font-size: 19px;
            line-height: 28px;
        }

        h2 {
            font-size: 19px;
        }
    }

    @media (max-width: 480px) {
        h1 {
            font-size: 17px;
            line-height: 25px;
        }

        h2 {
            font-size: 18px;
        }
    }
`;

/* =========================================================
   TOP SECTION
========================================================= */

const TopSection = styled.div`
    width: 100%;
    max-width: 1200px;

    display: flex;
    flex-direction: column;
    align-items: center;

    gap: 2rem;

    margin-bottom: 4.5rem;

    .top-para {
        width: 100%;

        color: #fff;

        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;

        text-transform: capitalize;
    }

    .promotion-period {
        color: #fff;

        font-size: 16px;
        font-weight: 400;
        line-height: 24px;

        text-align: center;
    }

    .promotion-period strong {
        font-weight: 700;
    }

    @media (max-width: 768px) {
        gap: 1.5rem;
        margin-bottom: 3.5rem;

        .top-para,
        .promotion-period {
            font-size: 14px;
            line-height: 21px;
        }

        .desktop-break {
            display: none;
        }
    }
`;

/* =========================================================
   COMMON SECTION
========================================================= */

const Section = styled.section`
    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;

    margin-bottom: 4rem;

    .section-description {
        margin-top: 1.5rem;

        color: #fff;

        text-align: center;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;

        text-transform: capitalize;
    }

    @media (max-width: 768px) {
        margin-bottom: 3rem;

        .section-description {
            margin-top: 1rem;

            padding: 0 10px;

            font-size: 14px;
            line-height: 21px;
        }
    }
`;

/* =========================================================
   GAME CARDS
========================================================= */

const GamesWrapper = styled.div`
    width: 100%;
    max-width: 700px;

    margin: 1.5rem auto 0;

    display: grid;
    grid-template-columns: repeat(3, 1fr);

    justify-content: center;
    align-items: stretch;

    gap: 18px;

    @media (max-width: 768px) {
        max-width: 600px;

        gap: 12px;
    }

    @media (max-width: 600px) {
        width: 90%;

        grid-template-columns: 1fr;

        max-width: 280px;

        gap: 16px;
    }
`;

const GameLink = styled.a`
    width: 100%;

    display: block;

    border-radius: 15px;
    overflow: hidden;

    cursor: pointer;

    text-decoration: none;

    transition:
        transform 0.25s ease,
        filter 0.25s ease;

    img {
        width: 100%;
        height: auto;

        display: block;

        border-radius: 15px;
    }

    &:hover {
        transform: translateY(-5px);
        filter: brightness(1.07);
    }

    &:active {
        transform: translateY(-2px);
    }
`;

/* =========================================================
   HOW TO CLAIM IMAGE
========================================================= */

const ImageWrapper = styled.div`
    width: 65%;
    max-width: 850px;

    margin: 2rem auto 0;

    display: flex;
    justify-content: center;
    align-items: center;

    img {
        width: 100%;
        height: auto;
        display: block;
    }

    @media (max-width: 992px) {
        width: 80%;
    }

    @media (max-width: 768px) {
        width: 95%;
        margin-top: 1.5rem;
    }
`;

/* =========================================================
   TERMS & CONDITIONS
========================================================= */

const TermsList = styled.ul`
    width: 46%;
    max-width: 700px;

    display: flex;
    justify-content: center;
    align-items: stretch;
    flex-direction: column;

    gap: 10px;

    margin: 2rem auto 0;
    padding: 0;

    list-style: none;

    li {
        position: relative;

        color: #fff;
        background: rgba(58, 58, 58, 0.92);
        font-size: 16px;
        font-style: normal;
        font-weight: 400;

        text-align: left;

        line-height: 25px;
        text-transform: capitalize;

        padding: 10px 1.5rem 10px 2.7rem;
    }

    li::before {
        content: "✦";

        position: absolute;

        left: 1.5rem;
        top: 10px;

        color: #fff;

        font-size: 13px;
    }

    li strong {
        font-weight: 700;
    }

    @media (max-width: 992px) {
        width: 65%;
    }

    @media (max-width: 768px) {
        width: 90%;

        margin-top: 1.5rem;

        li {
            font-size: 14px;
            line-height: 22px;

            padding: 10px 14px 10px 34px;
        }

        li::before {
            left: 15px;
        }
    }

    @media (max-width: 480px) {
        width: 95%;

        li {
            font-size: 13px;
            line-height: 20px;
        }
    }
`;